export enum BusinessType {
    Business,
    Wholesaler,
    Office,
    NeighborhoodCommunity,
    Grouping,
    Diocese,
    Vicarage,
    ParishUnit,
    Parish,
    Carrier
}
